<template>
  <li class="notification-item" :class="notification.type + 'type'">
    <a :href="notification.link" @click="dismiss">
      <span v-if="notification.type === 'program'" class="notification-icon">{{
        notification.count
      }}</span>
      <img
        v-if="notification.icon"
        class="notification-icon"
        :class="{ 'color-bg-primary': notification.type === 'renewal' }"
        :src="notification.icon"
      />

      <div v-if="notification.type === 'program'" class="notification-image">
        <img :src="notification.image" :alt="notification.program" />
        <span>{{ notification.program }}</span>
      </div>

      <p class="notification-text" v-html="notification.message"></p>
    </a>
  </li>
</template>

<style lang="less" scoped>
.notification-item {
  position: relative;
  padding-left: 60px;
  min-height: 50px;
  margin-bottom: 30px;

  &.unread:before {
    content: "";
    display: block;
    position: absolute;
    background-color: #f5b;
    height: 12px;
    width: 12px;
    border-radius: 999px;
    top: -6px;
    left: -6px;
  }
}

.notification-icon {
  background-color: #ddd;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 50px;
  width: 50px;
  border-radius: 999px;
  text-align: center;
  line-height: 48px;
  font-size: 22px;
  font-weight: bold;
  color: black;
}

.notification-image {
  width: 160px;
  height: 100px;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  padding: 10px;
  margin-bottom: 15px;

  img {
    display: block;
    position: absolute;
    height: 100%;
    width: 100%;
    object-position: center;
    object-fit: cover;
    top: 0;
    left: 0;
  }

  span {
    position: relative;
    color: white;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
    font-weight: bold;
    line-height: 1.1em;
  }
}

p.notification-text {
  font-size: 1.1em;
  margin-bottom: 15px;

  /deep/ strong {
    font-weight: bold;
  }

  /deep/ em {
    text-decoration: underline;
  }

  .notification-text::v-deep {
    i {
      font-style: oblique;
    }
  }
}
</style>

<script>
import axios from 'axios';

export default {
  props: ["notification"],
  computed: {
    routerLink() {
      if (this.notification.link.includes('?journey=')) {
          return {
            query: {
              journey: this.notification.link.split('?journey=')[1]
            }
          };
      } else {
        return this.notification.link;
      }
    }
  },
  methods: {
    dismiss(event) {
      event.preventDefault();
      if (this.notification.link) {
        if (this.notification.popup) {
          this.$emit('dismissed');
        }
        this.$store.commit("setMenuOpen", null);
        if (this.notification.type == "program") {
          window.location = this.notification.link;
        }
        else {
          this.$router.push(this.routerLink);
        }
      }
    }
  }
};
</script>
